import {useCallback, useEffect} from "react";
import {useComputed, useSignal} from "@preact/signals-react";
import {isEmpty, getSubmit, postSubmit} from "@ui-seeker/utils";

import {isSystemBusy} from "@signals";
import {BACKEND_APIS} from "@constants";
import {useToast} from "@hooks";
import {TABS_OFFERS} from "../@constants"
import {customDashboardsPrimorIsLoadingOffers, customDashboardsPrimorTabID, flashOffersError} from "../@signals"


export default function useCustomDashboardsPrimorFlashOffersOffers() {
	const { showToast } = useToast()
	const isLoading = useSignal(true)
	const dataDruni = useSignal({})
	const dataPrimor = useSignal({})

	useEffect(() => {
		handleSubmit()
	}, []);

	useEffect(() => {
		customDashboardsPrimorIsLoadingOffers.value = isLoading.value
		if (!isLoading.value) customDashboardsPrimorTabID.value = TABS_OFFERS.DRUNI
	}, [isLoading.value])

	const handleSubmit = ( force=0 ) => {
		postSubmit(`${BACKEND_APIS.CUSTOM_DASHBOARD}/flash-offers/context`, {force: force}).then(res => {
			dataDruni.value = res.druniData
			dataPrimor.value = res.primorData
			isLoading.value = false
		}).catch(async (error) => {
			showToast.error()
			dataDruni.value = {}
			dataPrimor.value = {}

			let errJson = null
			if (error instanceof Response) {
				try {
					errJson = await error.json()
				} catch {
					errJson = null
				}
			}

			if (errJson?.code) {
				flashOffersError.value = errJson.code
			} else {
				isSystemBusy.value = true
			}
			isLoading.value = false
		})
	}

	const handleChangeReloadData = useCallback(() => {
		isLoading.value = true;
		handleSubmit(1)
	}, [])

	const handleExcel = useCallback(() => showToast.promiseExcel(
		`${BACKEND_APIS.CUSTOM_DASHBOARD}/flash-offers/excel`, {}, null, {
			onError: data => {
				console.log('error')
				if (data.toString().includes('Error')) return 'Excel file size exceeded'
			}
		}), [])

	return {
		isLoading: isLoading.value,
		dataDruni: dataDruni.value,
		dataPrimor: dataPrimor.value,

		handleChangeReloadData,
		handleExcel
	}

}